<section class="container py-5 lg:py-8">
  <div class="col-span-12">
    <header class="widget-section__header">
      <h2 class="title-5 lg:text-3xl">
        {{ section.section_informations.title }}
      </h2>
    </header>

    <div
      class="widget-section__description"
      [innerHtml]="section.section_informations.description | safeHtml"
    ></div>

    <iframe
      class="widget-section__widget"
      [src]="section.url | safeUrl"
      allowfullscreen
      title=""
    ></iframe>

    <a
      [href]="section.cta.link"
      app-vtmn-play-button
      ctaClass="mx-auto mt-7 h-7 lg:mt-6"
    >
      {{ section.cta.label }}
    </a>
  </div>
</section>
